import React, { useState } from "react";

import MedicacionInfoAdicionalMedicamento from "./MedicacionInfoAdicionalMedicamento";
import { CONVENIO_SCIENZA } from "../../../utils/constants";

export const MedicacionMedicamento = (props) => {
  const [cantidad, setCantidad] = useState(
    props.medicamento ? (props.medicamento?.cantidad > 0 ? props.medicamento?.cantidad : 1) : 1
  );
  const [dosis, setDosis] = useState(
    props.medicamento ? props.medicamento?.dosis : ""
  );
  const [posologia, setPosologia] = useState(
    props.medicamento ? props.medicamento?.posologia : ""
  );
  const [surge, setSurge] = useState(props.medicamento ? props.medicamento.surge : false);

  const [idConvenioSC, setIdConvenioSC] = useState(props.medicamento ? props.medicamento.idConvenioSC : (props.idTipoEmpadronamiento ? CONVENIO_SCIENZA.NA_COBERTURA_100 : null));

  return (
    <React.Fragment>
      {
        <MedicacionInfoAdicionalMedicamento
          medicamento={props.medicamento}
          cantidad={cantidad}
          setCantidad={setCantidad}
          dosis={dosis}
          setDosis={setDosis}
          posologia={posologia}
          setPosologia={setPosologia}
          surge={surge}
          setSurge={setSurge}
          desdeIngreso={props.desdeIngreso}
          disabledEnGestionar={props.disabledEnGestionar}
          idConvenioSC={idConvenioSC}
          setIdConvenioSC={setIdConvenioSC}
        />
      }
    </React.Fragment>
  );
};
